import {Injectable, NgZone} from '@angular/core'
import {Platform, LoadingController} from 'ionic-angular';
import {Globales} from './funciones';

import {File} from '@ionic-native/file';
import {FileTransfer} from '@ionic-native/file-transfer';
import {FileOpener} from '@ionic-native/file-opener';

@Injectable()

export class CatalogoPDF {

  transfer = this.ft.create();
  progres: any;
  global_loading: any;

  constructor(
    public zone: NgZone,
    public platform: Platform,
    public loadCtrl: LoadingController,
    public gl: Globales,
    public file: File,
    public ft: FileTransfer,
    public fileOpener: FileOpener,
  ) {

    if (this.platform.is('android') || this.platform.is('ios')) {

    }

    this.transfer.onProgress((progressEvent) => {

      console.log(this.progres);
      console.log(progressEvent);


      this.zone.run(() => {
        this.global_loading.setContent(this.progres);
      });


      if (progressEvent.lengthComputable) {

        var perc = Math.floor(progressEvent.loaded / progressEvent.total * 100);
        this.progres = 'Descargado: ' + perc + '%';

      } else {

        if (!this.progres || this.progres == "") {

          this.progres = "Descargando";
        } else {

          this.progres += ".";
        }
      }
    });
  }


  openLocalPdf(filePath, tittle = 'Catalogo PDF', type = 'application/pdf') {


    if (this.platform.is('ios') && false) {

      /*
      let options: DocumentViewerOptions = {
        title: tittle
      };

      this.document.viewDocument(filePath, type, options);

       */

    } else {

      this.fileOpener.open(filePath, type)
        .then(() => console.log('File is opened'))
        .catch(e => console.log('Error opening file', e));
    }
  }


  /**
   * Descarga y abre el PDF
   *
   */
  downloadAndOpenPdf(url, titulo = 'myfile', type = 'application/pdf', ext = 'pdf') {

    this.global_loading = this.loadCtrl.create({
      content: '',
    });
    this.global_loading.present();

    let downloadUrl = url;
    let path = this.file.dataDirectory;

    this.progres = 'Descargando';

    this.transfer.download(downloadUrl, path + titulo + '.' + ext).then(entry => {

      this.global_loading.dismiss();

      let url = entry.toURL();
      this.openLocalPdf(url, titulo, type);
    });
  }


}



// WEBPACK FOOTER //
// ./src/classes/catalogoPDF.ts